export default {
  businessType: 'Business Type',
  grDate: 'Date',
  reworkDate: 'Rework Date',
  cartonPe: 'Carton PE',
  summary: 'Summary',
  vendor: 'Vendor',
  plant: 'Plant',
  byCarton: 'By Carton',
  byUnit: 'By Unit',
  giedASNQty: 'GIed/ASN Qty (Carton)',
  giedASNQtyByUnit: 'GIed/ASN Qty (Unit)',
  reworkQty: 'Rework TTL (Carton)',
  rework: 'Rework %',
  specialProductQty: 'Special Product (Carton)',
  productShortageQty: 'Product Shortage',
  productOverageQty: 'Product Overage',
  physicalSkuIncorrectQty: 'Product Mix',
  manualUnitScanQty: 'Unit Scan TTL',
  submitSysUpdateQty: 'No action',
  relabelQty: 'Relabel TTL (Carton)',
  relabel: 'Relabel %',
  noRfidTagQty: 'No RFID (Carton)',
  scanNoResponseQty: 'RFID Invalid (Carton)',
  multipleRfidCartonQty: 'Multiple RFID (Carton)',
  physicalSkuCorrectQty: 'Wrong RFID (Carton)',
  reworkQtyByUnit: 'Rework TTL (Unit)',
  specialProductQtyByUnit: 'Special Product (Unit)',
  physicalSkuIncorrectQtyByUnit: 'Product Mix (Unit)',
  relabelQtyByUnit: 'Relabel TTL (Unit)',
  noRfidTagQtyByUnit: 'No RFID (Unit)',
  scanNoResponseQtyByUnit: 'Invalid RFID (Unit)',
  multipleRfidCartonQtyByUnit: 'Multiple RFID (Unit)',
  physicalSkuCorrectQtyByUnit: 'Wrong RFID (Unit)'
}
